import * as React from "react";
import ErrorText from "../../atoms/ErrorText/index";
import styles from "./styles.scss";

interface FormErrorProps {
  name: string;
  errors: Record<string, string>;
  touched: Record<string, boolean>;
}

export const FormError: React.FC<FormErrorProps> = ({
  name,
  errors,
  touched,
}) => {
  if (errors[name] && touched[name]) {
    return <ErrorText className={styles.errors}>{errors[name]}</ErrorText>;
  }
  return null;
};
